require('./prtv-interface-4.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';
import { TYPE_CONSTRUCTION } from '../../../common/model';
import DateUtil from '../../../../utils/date.util';

export default class PrtvInterface4Component {
  constructor() {
    this.controller = PrtvInterface4Controller;
    this.template = require('./prtv-interface-4.html');
  }
}

// @ngInject
class PrtvInterface4Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.TYPE_CONSTRUCTION = TYPE_CONSTRUCTION;
    this.dateMax = new Date().toString();
    this.firstPerturbationDateIsvalid = true;
    this.data = {
      isConstructionKnowledge: false,
      is5KmAround: false,
      constructionType: '',
      firstPerturbationDate: null,
    };
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.PRTV_INTERFACE_4));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier :
            state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          data: state.demande.data.prtvInterface4 ? state.demande.data.prtvInterface4.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
        };
      }
    )(this);
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
    this.disableNext = true;
  }

  onChangeFirstPertubationDate() {
    this.firstPerturbationDateIsvalid = DateUtil.validate(this.data.firstPerturbationDate);
  }

  onChangeIsConstructionKnowledge() {
    if (!this.data.isConstructionKnowledge) {
      this.data.is5KmAround = false;
      this.data.constructionType = '';
      this.data.firstPerturbationDate = null;
    }
  }
  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface4(this.data, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface4(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/prtv/components/prtv-interface-4/prtv-interface-4.component.js